import { axios, axiosSilent } from '../utils/axios';


export const registerApi = (body) => {
  return axios.post("user/register", body);
};

export const userListApi = (query) => {
  return axios.get("user/fetchUserList?" + query);
};

export const reporteesListApi = (city, role) => {
  return axios.get(`user/reporteesList?city=${city}&role=${role}`);
};

export const rolesListApi = () => {
  return axios.get(`user/roles`);
};

export const removeRegisterUserApi = (id) => {
    return axios.delete(`user/remove/`+id);
}

export const updateUserApi = (id, body) => {
    return axios.put('user/update/'+id, body);
}

export const fetchUserListUsingSearch = (query) => {
    return axiosSilent.get('user/myTeamUsingSearch?'+ query );
}

export const forgotPassword = (email) => {
  return axios.post("user/forgotPassword", { email });
};

export const resetPassword = (body) => {
  return axios.post("user/resetPassword", body);
};